import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiApplyPromo, apiCreatePaymentIntent, apiRemovePromo, apiV2PricingSummary, } from "Root/api/apiCheckout";
import { updateUserCart } from "./checkoutUserCartSlice";
import toastService from "Root/profile/toastService";
const initState = {
    promoError: "",
    clientSecret: "",
    plan: "subscription",
    subscription: {
        subtotal: 0,
        shipping: 0,
        tax_fees: 0,
        total: 0,
        discount: 0,
        duty: 0,
        otb_fee: 0,
        promo_error: "",
        promo_code: "",
        promo_otb_allowed: false,
        promo_type: "",
    },
    otb: {
        subtotal: 0,
        shipping: 0,
        tax_fees: 0,
        total: 0,
        discount: 0,
        duty: 0,
        otb_fee: 0,
        promo_error: "",
        promo_code: [],
        promo_otb_allowed: false,
        promo_type: "",
        delivery_frequency: ""
    },
    showOTB: false,
};
export const createPaymentIntent = createAsyncThunk("checkoutPricing/createPaymentIntent", async ({ shippingSpeed, isOtb }, { dispatch }) => {
    try {
        const data = await apiCreatePaymentIntent({
            shippingAddress: "{}",
            shippingSpeed: shippingSpeed,
            isStarterKit: false,
            otb: isOtb,
        });
        if (data.clientSecret === "complete") {
            window.location.href = "/app/thank-you/";
        }
        return data.clientSecret || "";
    }
    catch (err) {
        toastService.errorMessage("Something went wrong");
        return "";
    }
});
export const applyPromoCheckout = createAsyncThunk("checkoutPricing/applyPromo", async (input, { dispatch, getState }) => {
    try {
        const { checkoutPricing } = getState();
        const data = await apiApplyPromo(input);
        dispatch(updateUserCart(data.userCart));
        await dispatch(createPaymentIntent({ shippingSpeed: input.shippingSpeed, isOtb: input.isOtb }));
        await dispatch(fetchPricing(input.shippingSpeed));
        if (checkoutPricing.promoError) {
            dispatch(setPromoError(""));
        }
        return data;
    }
    catch (e) {
        dispatch(setPromoError(e.detail || e.message.replaceAll('"', "")));
        throw e;
    }
});
export const removePromoCheckout = createAsyncThunk("checkoutPricing/removePromo", async (input, { dispatch, getState }) => {
    const data = await apiRemovePromo(input);
    const { checkoutPricing } = getState();
    dispatch(updateUserCart(data.userCart));
    await dispatch(createPaymentIntent({ shippingSpeed: input.shippingSpeed, isOtb: input.isOtb }));
    await dispatch(fetchPricing(input.shippingSpeed));
    if (checkoutPricing.promoError) {
        dispatch(setPromoError(""));
    }
    return data;
});
export const fetchPricing = createAsyncThunk("users/fetchPricing", async (shippingMethod, { dispatch, getState }) => {
    const [sub, otb] = await Promise.all([
        apiV2PricingSummary(shippingMethod, false),
        apiV2PricingSummary(shippingMethod, true),
    ]);
    return {
        subscription: sub,
        otb: otb,
    };
});
const checkoutPricingSlice = createSlice({
    name: "checkoutPricing",
    initialState: initState,
    reducers: {
        setPromoError(state, action) {
            state.promoError = action.payload;
        },
        setDiscountStr(state, action) {
            state.otb.promo_code = action.payload;
            state.subscription.promo_code = action.payload;
            return state;
        },
        setPlan(state, action) {
            state.plan = action.payload;
            return state;
        },
        setShowOTB(state, action) {
            state.showOTB = action.payload;
            return state;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(fetchPricing.fulfilled, (state, action) => {
            state.otb = action.payload.otb;
            state.subscription = action.payload.subscription;
        });
        builder.addCase(createPaymentIntent.fulfilled, (state, action) => {
            state.clientSecret = action.payload;
        });
    },
});
export const { setPromoError, setDiscountStr, setPlan, setShowOTB } = checkoutPricingSlice.actions;
export default checkoutPricingSlice.reducer;
